var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inputs)?_c('div',{staticClass:"sub-section"},[_c('b-field',{staticClass:"input-field"},[_c('b-switch',{staticClass:"mt-4",attrs:{"type":"is-info"},model:{value:(_vm.inputs.show_header),callback:function ($$v) {_vm.$set(_vm.inputs, "show_header", $$v)},expression:"inputs.show_header"}},[_vm._v(" Show Header ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }